import { useState } from 'react';
import useGetUsers from '../../API/hooks/users/useGetUsers';
import { FilterConfig } from '../../components/common/DropdownFilter/types';
import { IconKeys } from '../../components/common/Icon/IconKeys';
import Modal from '../../components/common/Modal/Modal';
import Toolbar from '../../components/common/Toolbar/Toolbar';
import S from './UsersPageStyles';
import ItemsList from '../../components/common/ItemsList/ItemsList';
import useGetFleetId from '../../API/hooks/useGetFleetId';
import useGetRole from '../../API/hooks/useGetRole';
import UsersItem from './UsersItem/UsersItem';
import AddUser from './Modals/AddUser/AddUser';
import { getLocalStorageKey } from '../../utils/storageUtils';
import useGetCurrentPage from '../../API/hooks/useGetCurrentPage';
import { usersPageFilters } from '../../constants/FilterDefault';
import useLocalStorage from '../../API/hooks/useLocalStorage';

const SEARCH_CONFIG = [
  {
    type: 'role',
    display: 'radio',
    options: [
      { null: 'All' },
      { fleetAdmin: 'Fleet Admin' },
      { fleetManager: 'Fleet Manager' },
      { fleetViewer: 'Fleet Viewer' },
    ],
  },
  // {
  //   type: 'status',
  //   display: 'radio',
  //   options: [
  //     { null: 'All' },
  //     { active: 'Active' },
  //     { inactive: 'Inactive' },
  //   ],
  // },
  {
    type: 'sortBy',
    display: 'radio',
    options: [
      { name_ASC: 'User name: asc' },
      { name_DESC: 'User name: desc' },
    ],
  },
] as FilterConfig[];

function UsersPage(): JSX.Element {
  const fleetId = useGetFleetId();
  const {
    isFleetViewer,
  } = useGetRole();
  const [addUserModalOpen, toggleAddUserModal] = useState(false);
  const [filters, setFilters] = useLocalStorage(getLocalStorageKey('users-page-filters'), usersPageFilters);
  const currentPage = useGetCurrentPage();

  const BUTTONS = [
    {
      title: 'Add new user',
      iconKey: IconKeys.PLUS,
      action: () => toggleAddUserModal(true),
      hide: isFleetViewer,
    },
  ];

  return (
    <S.Wrapper>
      <Toolbar title="Users" buttons={!isFleetViewer ? BUTTONS : []} />
      <ItemsList
        entity="users"
        fleetId={fleetId}
        filtersConfig={SEARCH_CONFIG}
        filters={filters}
        defaultFilters={usersPageFilters}
        setFilters={setFilters}
        // hasSearch
        getQuery={useGetUsers}
        curentPage={currentPage}
      >
        <UsersItem />
      </ItemsList>
      {addUserModalOpen && (
        <Modal
          title="Add new user"
          state={addUserModalOpen}
          toggleState={toggleAddUserModal}
        >
          <AddUser fleetId={fleetId} toggleModal={toggleAddUserModal} />
        </Modal>
      )}
    </S.Wrapper>
  );
}

export default UsersPage;
